export const ssrBloquers = "ARPL,AVIH,DPNA,ESAN,BIKE,BSCT,CBBG,DEPA,DEPU,ESCT,GARD,MEDA," +
  "OXYG,OXGN,PETC,STCR,SVAN,TWOV,VICC";

export const ssrsChairAssistant = ["UMNR","WCBD","WCBW","WCHC","WCHR","WCHS","WCLB","WCMP","WCOB"];
